import React from "react";

import ChangeSubscriptionStatus from "../changeSubscriptionStatus/changeSubscriptionStatus";

function SubscribeModalRow(props) {
  const {
    apiProductUuid,
    subscribeApiProductToApplication,
    unsubscribeFromApiProduct,
    onAppSelectHandler,
    selectedAppForSubscribe,
    clearSubscribeErrorMessage,
    loading,
  } = props;
  const { title, subscriptions, uuid, applicationStatus, organizationName } =
    props;

  console.log(
    "SubscribeModalRow - app:",
    title,
    "org:",
    organizationName,
    "status:",
    applicationStatus,
    "subscriptions:",
    subscriptions,
    "apiProductUuid:",
    apiProductUuid
  );

  const subscribed =
    subscriptions &&
    subscriptions.findIndex((s) => s.uuid === apiProductUuid) > -1;

  console.log("Subscribed status:", subscribed, "for app:", title);

  const changeSubscriptionStatus = (type, apiProductUuid, uuid) => {
    onAppSelectHandler(uuid);
    // Clear any existing error message when performing new action
    if (clearSubscribeErrorMessage) {
      clearSubscribeErrorMessage();
    }
    const actionToPerform = type
      ? subscribeApiProductToApplication
      : unsubscribeFromApiProduct;
    actionToPerform({ apiProductUuid, planUuid: uuid });
  };

  return (
    <li className="row line">
      <div className="cell forum">{title}</div>
      <div className="cell forum">{organizationName || "Unknown"}</div>
      <div className="cell forum" style={{ textTransform: "lowercase" }}>
        {applicationStatus}
      </div>
      <div className="cell tr_white posts">
        <ChangeSubscriptionStatus
          button
          withIcon
          circleIcon
          subscribed={subscribed}
          appId={uuid}
          passiveVerbs
          loading={selectedAppForSubscribe === uuid && loading}
          changeSubscriptionStatus={({ type }) => {
            changeSubscriptionStatus(type, apiProductUuid, uuid);
          }}
          applicationStatus={applicationStatus}
        />
      </div>
    </li>
  );
}

export default SubscribeModalRow;
